export default __webpack_public_path__ + "static/media/check-icon.809eb43b.svg";